"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldPort = void 0;
const Colors_1 = require("../../../../Colors");
const Icons = __importStar(require("../../../icons/index"));
const react_1 = __importDefault(require("react"));
const typestyle_1 = require("typestyle");
const Main = typestyle_1.style({
    position: 'relative',
    width: 18,
    height: 18,
    borderRadius: 2,
    fontSize: 7,
    margin: `0 4px`,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: `${Colors_1.Colors.grey[9]}00`,
    cursor: 'pointer',
    transition: 'all 0.25s ease-in-out',
    $nest: {
        '&:hover': {
            backgroundColor: `${Colors_1.Colors.grey[9]}ff !important`,
            $nest: {
                '.EditArguments': {
                    display: 'block',
                },
                '.ExpandDetails': {
                    display: 'block',
                },
                '.OpenerIcon': {
                    opacity: `1.0 !important`,
                },
            },
        },
        '.OpenerIcon': {
            opacity: 0.0,
            transition: 'all 0.25s ease-in-out',
        },
        '.EditArguments': {
            position: 'absolute',
            display: 'none',
            width: 150,
            fontSize: 10,
            color: Colors_1.Colors.yellow[0],
            $nest: {
                '&.top': {
                    left: -75,
                    top: -30,
                    textAlign: 'center',
                },
                '&.left': {
                    left: -160,
                    textAlign: 'right',
                },
                '&.bottom': {
                    left: -75,
                    bottom: -30,
                    textAlign: 'center',
                },
                '&.right': {
                    textAlign: 'left',
                    right: -160,
                },
            },
        },
    },
});
exports.FieldPort = ({ children, onClick, open, info, icons = { closed: 'Plus', open: 'Minus' }, }) => {
    const OpenComponent = Icons[icons.open];
    const ClosedComponent = Icons[icons.closed];
    return (react_1.default.createElement("div", { className: `${Main} NodeFieldPort`, onClick: onClick },
        !open && info && react_1.default.createElement("div", { className: `EditArguments ${info.placement}` }, info.message),
        open ? (react_1.default.createElement(OpenComponent, { className: 'OpenerIcon', height: 6, width: 6 })) : (react_1.default.createElement(ClosedComponent, { className: 'OpenerIcon', height: 8, width: 8 })),
        children));
};
